export default __webpack_public_path__ + "static/media/waiting.0ab22d2b.gif";